import React from 'react';
import CookieBanner from './CookieBanner';
import TermsUpdateBanner from './TermsUpdateBanner';

// Shared fixed-bottom positioning for all bottom-anchored notice banners, so they stack
// vertically instead of rendering on top of each other when more than one is visible at
// once (e.g. a first-time visitor who hasn't accepted cookies yet, during an active Terms
// pendingChange window). Each banner still owns its own visibility/dismiss logic — this
// component only owns the shared layout. column-reverse + CookieBanner first in DOM order
// keeps CookieBanner anchored at the very bottom (its original position) with
// TermsUpdateBanner stacking above it.
const NoticeBannerStack: React.FC = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex flex-col-reverse gap-3 p-4 md:p-6 pointer-events-none">
      <CookieBanner />
      <TermsUpdateBanner />
    </div>
  );
};

export default NoticeBannerStack;
